import DeviceSdk from "../lib/deviceSdk";
import { Store } from "./app.store.service";

const channelNotFoundErrorTimeout = 1000;
export class NumericKeyPressService {
  static changeChannelTo(channelToChange) {
    DeviceSdk.tuneToChannelByNumber(
      Number(channelToChange ? channelToChange : Store.channelToChange)
    )
      .then(() => {
        Store.channelToChange = "";
      })
      .catch(error => {
        Store.channelToChange = "error";
        this.showChannelErrorTimeout = setTimeout(() => {
          Store.channelToChange = "";
          clearTimeout(this.showChannelErrorTimeout);
        }, channelNotFoundErrorTimeout);
      });
  }
}
